import { CategoryType } from 'types/category'

export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
export const fetchCategoriesAction = (categories: CategoryType[]) => {
  return {
    type: 'FETCH_CATEGORIES',
    payload: categories,
  }
}
